import { createSlice } from "@reduxjs/toolkit";
import { doDelContact, doFetchContactList } from "./contact.action";
import { Contact } from "../config";

interface Meta {
  totalItems: number;
  itemsPerPage: number;
  totalPages: number;
  currentCount: number;
}

interface ContactState {
  contacts: Contact[];
  meta: Meta | null;
  loading: boolean;
  error: string | null;
}

const initialState: ContactState = {
  contacts: [] as Contact[],
  meta: null,
  loading: false,
  error: null,
};

const contactSlice = createSlice({
  name: "contact",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // fetch list
    builder
      .addCase(doFetchContactList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchContactList.fulfilled, (state, action) => {
        state.loading = false;
        state.contacts = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchContactList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });

    // delete
    builder
      .addCase(doDelContact.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doDelContact.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;

        state.contacts = state.contacts.filter(
          (contact) => contact.contactUid !== action.meta.arg
        );
        if (state.meta) {
          state.meta.totalItems -= 1;
        }
      })
      .addCase(doDelContact.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default contactSlice.reducer;
